export class PolicyCount {
    public totalPolicies: number;
}